// extracted by mini-css-extract-plugin
export default {"container":"OneButton_container__jStyV","title":"OneButton_title__DlgoI","contents":"OneButton_contents__aio+n","btn_box":"OneButton_btn_box__9HCi0"};